export default __webpack_public_path__ + "static/media/cross-in-circle.ab49407d.svg";